/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService
 */

/**
 * Virtual record for map with known enum keys
 */

export const ExamTypename = 'com.hubspot.academy.core.models.content.Exam';
export const LinkAssetTypename = 'com.hubspot.academy.core.models.content.LinkAsset';
export const QuizAssetTypename = 'com.hubspot.academy.core.models.content.QuizAsset';
export const ChapterAssetTypename = 'com.hubspot.academy.core.models.content.chapter.ChapterAsset';
export const ExerciseAssetTypename = 'com.hubspot.academy.core.models.content.exercise.ExerciseAsset';
export const VideoAssetTypename = 'com.hubspot.academy.core.models.content.video.VideoAsset';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getHydratedLessonRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.LessonChirpService',
  rpcName: 'getHydratedLesson',
  auth: 'app',
  fingerprint: '3CtkfG4GFjw3918FoCepl19Ry1PAhX9Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHydratedLessonsRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.LessonChirpService',
  rpcName: 'getHydratedLessons',
  auth: 'app',
  fingerprint: '1VzsgqKilCX0QCw7PA-FX5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHydratedPartnerLessonsRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.LessonChirpService',
  rpcName: 'getHydratedPartnerLessons',
  auth: 'app',
  fingerprint: 'cuClgUvygV_Qcq4MTKcQHpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};